export Profile from './Profile';
export Logout from '../components/Logout';




// WEBPACK FOOTER //
// ./src/modules/profile/containers/index.js